import type { ISourcesStore } from '~/modules/main'

export const state = (): ISourcesStore => {
  return {
    splash: null,
    isAllLoaded: false,
  }
}
